import { shuffleArray } from 'lib/utilityFunctions';
import { GAME_ID, REDUX_ACTIONS } from 'a/estaOAquella/data/constants';
import { retrieveQueue } from '../../content/curriculum';

export const initialState = {
  roundNumber: 1,
  setNumber: 1,
  categories: [],
  queue: [],
  sortedItems: {},
  currentQueueItem: null,
  questionsAnswered: 0,
  answersCorrect: 0,
  answersIncorrect: 0,
  answerAttemptsCounters: {},
  interactionLocked: false,
};

const roundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ROUND_WORDS: {
      const queue = retrieveQueue(action.payload.level, action.payload.set);
      const [{ categories }] = queue;

      return {
        ...initialState,
        categories: queue[0].categories,
        queue,
        currentQueueItem: queue.shift(),
        sortedItems: {
          [categories[0]]: [],
          [categories[1]]: [],
        },
        roundNumber: action.payload.level,
        setNumber: action.payload.set,
      };
    }
    case REDUX_ACTIONS.INIT_ROUND_IMAGES: {
      const { sortedItems } = state;
      const [leftCategory, rightCategory] = Object.keys(sortedItems);
      const resetQueue = shuffleArray([...sortedItems[leftCategory], ...sortedItems[rightCategory]]);
      return {
        ...state,
        queue: resetQueue,
        sortedItems: { [leftCategory]: [], [rightCategory]: [] },
        currentQueueItem: resetQueue.shift(),
        answerAttemptsCounters: {},
      };
    }
    case REDUX_ACTIONS.SET_INTERACTION_LOCKED:

      return {
        ...state,
        interactionLocked: action.payload.interactionLocked,
      };
    case REDUX_ACTIONS.MOVE_TO_CATEGORY: {
      const { currentQueueItem, sortedItems } = state;
      const { payload: { category } } = action;

      return {
        ...state,
        sortedItems: {
          ...sortedItems,
          [category]: [...sortedItems[category], currentQueueItem],
        },
      };
    }
    case REDUX_ACTIONS.INCREMENT_QUESTIONS_ANSWERED:
      return {
        ...state,
        questionsAnswered: state.questionsAnswered + 1,
      };

    case REDUX_ACTIONS.INCREMENT_ANSWERS_CORRECT:
      return {
        ...state,
        answersCorrect: state.answersCorrect + 1,
      };
    case REDUX_ACTIONS.INCREMENT_ANSWERS_INCORRECT:
      return {
        ...state,
        answersIncorrect: state.answersIncorrect + 1,
      };
    case REDUX_ACTIONS.INCREMENT_ATTEMPTS_COUNTER:
      return {
        ...state,
        answerAttemptsCounters: {
          ...state.answerAttemptsCounters,
          [action.payload.word]: (state.answerAttemptsCounters[action.payload.word] || 0) + 1,
        },
      };
    case REDUX_ACTIONS.NEXT_QUEUE_ITEM: {
      const { answerIsCorrect, isImageQuestion } = action.payload;
      const { answerAttemptsCounters, currentQueueItem, queue } = state;
      const prevQueue = queue.slice();
      const prevItem = currentQueueItem;

      // unlimited tries in Part I of round (words)
      // max 2 tries in Part II of round (images)
      if (
        !answerIsCorrect
        && (!isImageQuestion || (isImageQuestion && (answerAttemptsCounters[prevItem.word] || 0) < 2))
      ) {
        prevQueue.push(prevItem);
      }
      const nextItem = prevQueue.shift();

      return {
        ...state,
        categories: nextItem.categories,
        currentQueueItem: nextItem,
        queue: prevQueue,
      };
    }
    case REDUX_ACTIONS.CHANGE_SET_NUMBER: {
      const { setNumber } = action.payload;
      return {
        ...state,
        setNumber,
      };
    }

    default:
      return state;
  }
};

export default roundReducer;
